// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 全局引入Toast
import './pages/Toast/toast.css';
import Toast from './pages/Toast/index';
import VueClipboard from 'vue-clipboard2'
import utils from './assets/js/urlGet'; //获取url参数
import './assets/css/reset.css';
import './assets/css/style.css';
import './assets/css/border.css';
import FastClick from 'fastclick'
import api from './assets/js/base.js';
import animated from 'animate.css' // 
import Meta from 'vue-meta'
 
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.use(Meta)
Vue.use(animated)
Vue.prototype.$api = api.commonUrl;
Vue.prototype.$utils = utils; //注册全局方法
Vue.use(VueClipboard)
Vue.use(Toast);
FastClick.attach(document.body);
Vue.config.productionTip = false
 


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
 


// WEBPACK FOOTER //
// ./src/main.js